import type { Logger } from '@dma/shared';
import type { AuthRepository } from '../../domain/repositories/AuthRepository.interface';
import type { AdminSession } from '../../domain/entities/AdminSession.entity';
import type { SignInDto } from '../dto/SignInDto';

/**
 * Use Case per the pattern established by SubmitContactMessageUseCase.
 * Credential validation (wrong email/password) is a legitimate business
 * outcome, not a system failure, so it is raised as a DomainError
 * (`AuthenticationFailedError`) by the repository and simply propagated —
 * this use case adds no extra validation of its own.
 */
export class SignInUseCase {
  constructor(
    private readonly repository: AuthRepository,
    private readonly logger: Logger
  ) {}

  public async execute(input: SignInDto): Promise<AdminSession> {
    const session = await this.repository.signIn(input.email, input.password);
    this.logger.info('Admin sign-in succeeded', { userId: session.user.id, role: session.user.role });
    return session;
  }
}
